// extracted by mini-css-extract-plugin
export default {"leave":"oi50d","leaveActive":"_5Lrit"};